import { render, staticRenderFns } from "./GJgrowEvent.vue?vue&type=template&id=dd784e1e&scoped=true&"
import script from "./GJgrowEvent.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEvent.vue?vue&type=script&lang=ts&"
import style0 from "./GJgrowEvent.vue?vue&type=style&index=0&id=dd784e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd784e1e",
  null
  
)

export default component.exports